import { gql, TypedDocumentNode } from "@apollo/client";

import {
  CreateCasePropertiesRuleMutation,
  CreateCasePropertiesRuleMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { ruleFragment } from "src/graphql/anti-fraud/fragments/RuleFragment";

export const CreateCasePropertiesRule = gql`
  mutation createCasePropertiesRule(
    $code: String!
    $name: String!
    $description: String!
    $caseTypeCode: String!
    $valueConditions: [ValueConditionInput!]
    $propertyConditions: [PropertyConditionInput!]
  ) {
    createCasePropertiesRule(
      input: {
        code: $code
        name: $name
        description: $description
        caseTypeCode: $caseTypeCode
        valueConditions: $valueConditions
        propertyConditions: $propertyConditions
      }
    ) {
      ...RuleFragment
    }
  }

  ${ruleFragment}
` as TypedDocumentNode<CreateCasePropertiesRuleMutation, CreateCasePropertiesRuleMutationVariables>;
